require('./bootstrap');

require("spectrum-colorpicker");

require("datatables");

require("datatables.net-select");

import Vue from 'vue';

import VueRouter from 'vue-router';

import routes from './adminRoutes';

import VueLoading from 'vuejs-loading-plugin';

import VueDatePicker from '@mathieustan/vue-datepicker';
import '@mathieustan/vue-datepicker/dist/vue-datepicker.min.css';

import Vuelidate from 'vuelidate';

import { Form, HasError, AlertError } from 'vform'

import Swal from 'sweetalert2'

window.Vue = Vue;

require('./progressbar');

require('./customEvents');

import VueQrcode from '@chenfengyuan/vue-qrcode';

Vue.use(VueRouter);

Vue.use(VueLoading);

Vue.use(VueDatePicker);

Vue.use(Vuelidate)

window.Form = Form;

Vue.component(HasError.name, HasError)

Vue.component(AlertError.name, AlertError)

Vue.mixin({
    data: function () {
        return {
            base_url: process.env.MIX_APP_URL,
            admin_auth: localStorage.admin_auth,
            package_name: '',
            admin_color: '#f6383e',
            adminInfo: { id: "", first_name: "", last_name: "", image: "" },
            packageInfo: { static_qr: 0, gps_checkin: 0, qr_card: 0 },
        }
    },
    methods: {
        // Admin
        adminLogin: function (admin) {
            this.$root.admin_auth = admin.token;
            localStorage.setItem("admin_auth", admin.token);
            this.loadProfile();
            // this.$router.push('/dashboard');
        },
        adminLogout: function () {
            this.$root.admin_auth = null;
            localStorage.removeItem("admin_auth");
            this.$router.push('/');
        },
        erroHandler: function (error) {
            // if(error.response.status===401)
            // {
            //    this.$root.admin_auth = null;
            //    localStorage.removeItem("admin_auth");
            //    this.$router.push('/');
            // }else{
            //    console.log(error);
            // }

        },
        loadProfile: function () {
            var token = localStorage.getItem("admin_auth");
            if (token != null) {
                axios.get(`/api/admin/profile`, {
                    headers: {
                        "X-Api-Key": 'Bearer ' + token
                    }
                })
                    .then(response => {
                        this.adminInfo = response.data.data;
                        this.package_name = response.data.data.package_name;
                        this.packageInfo = response.data.data.subscription_detail;
                    });
            }
        }
    },
});

window.axios.defaults.headers.common['X-Api-Key'] = `Bearer ${localStorage.getItem("admin_auth")}`;

Vue.component('admin-navigation', require('./components/Admin/Navigation').default);

Vue.component('admin-toolbar', require('./components/Admin/Toolbar').default);

Vue.component("vue-qrcode", VueQrcode);

Vue.component("data-table", require("./components/Admin/DataTable").default);

window.Swal = Swal
const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
})

window.Toast = Toast

const router = new VueRouter(routes);

let app = new Vue({
    el: '#app',
    router,
    watch: {
        '$route'(to, from) {
            document.title = to.meta.title || 'Tawajud Application'
        }
    },
    created() {
        this.loadProfile();
    }

});

router.beforeEach((to, from, next) => {

    if ((!localStorage.admin_auth || localStorage.admin_auth == '') && to.path != '/') {
        next('/');
    } else {
        app.$loading(true);
        next();
    }

    if (localStorage.admin_auth && localStorage.admin_auth != '' && to.path === '/') {
        next('/dashboard');
    } else {
        app.$loading(true);
        next();
    }

});

router.afterEach(() => {
    setTimeout(() => app.$loading(false), 1000)
});
